import React, { useEffect, useState } from 'react';
import { BaseUserInfo } from '../interface/BaseUserInfo';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import api from '../api/CallAdminApi';
import { useParams } from 'react-router-dom';
import InputLesson from '../components/InputLesson';
import { getLessonTmpById } from '../localStorageUtils';
import { ClassInfo } from '../interface/ClassInfo';
import HelpArea from '../components/HelpComponent';

const RegisterLesson: React.FunctionComponent = () => {
  const [userInfo, setUserInfo] = useState<BaseUserInfo>({} as BaseUserInfo);
  const [formData, setFormData] = useState<ClassInfo>({} as ClassInfo);
  const [reportId, setReportId] = useState<string>('');
  const navigate = useNavigate();
  const params = useParams();

  const nextPage = (): void => {
    navigate('/admin/report/edit/' + reportId + '/bigMediaCategory');
  };

  useEffect(() => {
    const getData = async () => {
      const profile: BaseUserInfo = await api.getProfile();
      setUserInfo(profile);
      const id = params ? params.reportId : '';
      if (!id) throw Error('report id パラメータが存在しません');
      setReportId(id);
      const lesson = getLessonTmpById(profile._id);
      if (lesson) {
        setFormData(lesson);
        return;
      }
      const report = await api.getReport(id);
      setFormData(report.classInfo);
    };
    getData();
  }, []);

  return (
    <>
      <Container>
        <Row>
          <Col md={9} lg={9}>
            <InputLesson userInfo={userInfo} movePage={nextPage} formData={formData} />
          </Col>
          <HelpArea helps={[]} />
        </Row>
      </Container>
    </>
  );
};
export default RegisterLesson;
